<template>
    <div class="saa">
        <b-card no-body class="p-3">
            <b-row align-v="center">
                <b-col cols="6">
                    <h3 class="mb-0">
                        SAA
                    </h3>
                </b-col>
                <b-col cols="6">
                    <span v-if="saa_issue.length > 0" class="float-right font-weight-600 text-danger">{{ saa_issue.length }} Issue{{ saa_issue.length > 1 ? 's' : '' }}</span>
                    <span v-else class="float-right text-muted">No Issue</span>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import { Card, Button } from 'element-ui'
import { mapState } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'

export default {
    name: 'saa-card',
    components: {
        [Card.name]: Card,
        [Button.name]: Button,
    },
    data() {
        return {
            saa_issue: '',
        }
    },
    computed:{
        ...mapState(useCustomerStore, ['current_commitment'])
    },
    watch: {
        current_commitment: {
            handler(newVal){
                if(newVal){
                    this.saa_issue = newVal.credit_report_summary.special_attensions
                }
            }
        }
    }
}
</script>